import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import CartTable from './CartTable';
import CartBudget from './CartBudget';

CartTableBudget.propTypes = {
  cart: PropTypes.object,
  canViewBudget: PropTypes.bool,
  singleCart: PropTypes.bool,
  showTableCheckbox: PropTypes.bool,
  facilityId: PropTypes.string,
  setBulkDeleteItems: PropTypes.func
};

export default function CartTableBudget({ cart, singleCart, canViewBudget, setBulkDeleteItems, showTableCheckbox, facilityId })
{
  return <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
    <Grid item xs={canViewBudget && cart.budget ? 9 : 12}>
      <CartTable
        cart={cart}
        setBulkDeleteItems={setBulkDeleteItems}
        canViewCart={canViewBudget}
        showTableCheckbox={showTableCheckbox}
        facilityId={facilityId}
        singleCart={singleCart}
      />
    </Grid>

    {canViewBudget && cart.budget && <CartBudget cart={cart} facilityId={facilityId} />}
  </Grid>;
}